import httpService from "../../services/httpService";
import { ApiEndpoints } from "../../constants/apiEndpoints";

// API Dokümantasyonuna uygun SongType interface
export interface SongType {
  songtype_id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}

// API Dokümantasyonuna uygun request interfaces
export interface CreateSongTypeRequest {
  name: string; // Required
  description?: string; // Optional
}

export interface UpdateSongTypeRequest {
  name?: string;
  description?: string;
}

// API Functions
export const fetchSongTypes = async (): Promise<SongType[]> => {
  const response = await httpService.get<SongType[]>(ApiEndpoints.SONG_TYPES);
  return response.data;
};

export const fetchSongType = async (id: number): Promise<SongType> => {
  const response = await httpService.get<SongType>(
    `${ApiEndpoints.SONG_TYPES}/${id}`
  );
  return response.data;
};

export const createSongType = async (
  data: CreateSongTypeRequest
): Promise<SongType> => {
  const response = await httpService.post<SongType>(
    ApiEndpoints.SONG_TYPES,
    data
  );
  return response.data;
};

export const updateSongType = async (
  id: number,
  data: UpdateSongTypeRequest
): Promise<SongType> => {
  const response = await httpService.put<SongType>(
    `${ApiEndpoints.SONG_TYPES}/${id}`,
    data
  );
  return response.data;
};

export const deleteSongType = async (id: number): Promise<void> => {
  await httpService.delete(`${ApiEndpoints.SONG_TYPES}/${id}`);
};
